import { useLocation } from "react-router-dom"

import { Box } from "./box"
import bkgImg from '../resources/GL_bkg.png'
import bkgImgAlternate from '../resources/GL_section_bkg_1.png'

export const Layout = ({ children }) => {
  const location = useLocation()

  return (
    <Box
      css={{
        maxW: "100%",
        minHeight: "1000px",
        backgroundSize: "150%",
        backgroundPosition: "top center",
        backgroundPositionY: "50px",
        backgroundImage: location.pathname === '/' ? `url(${bkgImg})` : "none",
        backgroundRepeat: "no-repeat",
        "@xsMin": {
            backgroundSize: "100%"
        },
        "@smMin": {
            // backgroundPositionY: "-150px"
        },
        "@mdMin": {
            // height: "900px",
            // backgroundPositionY: "-150px"
        }
      }}
    >
      {children}
    </Box>
  )
}
